(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cross-border"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ot-country-picker')) {
    customElements.define('ot-country-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.otInitialized) return;
        this.otInitialized = true;
        this.addEventListener('click', (event) => {
          const dialog = this.querySelector('dialog');
          if (!dialog) return;
          if (event.target.closest('[data-ot-country-open]')) {
            dialog.showModal();
          } else if (event.target.closest('[data-ot-country-close]')) {
            dialog.close();
          } else if (event.target === dialog) {
            const bounds = dialog.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
